/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import getRawReports from './get-raw-reports';

export default (state, id) => get(getRawReports(state), [id], null);